import { createContext, useContext } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Device, DeviceType } from '../utils/helpers/getDeviceType';
import { Photo } from '../graphql/graphql';

export interface PageProps {
  deviceType?: DeviceType;
  device?: Device;
  mainPageImage?: Photo;
}

export const PageContext = createContext<PageProps>({
  deviceType: DeviceType.desktop,
  device: { model: null, vendor: null },
  mainPageImage: {}
});

export const usePageProps = () => useContext(PageContext);
